const SET_PLAN_DATA = 'SET_PLAN_DATA';
const SET_SCENE_DATA = 'SET_SCENE_DATA';
const DO_CLOSE_PLAN = 'DO_CLOSE_PLAN';

import carePlan from '../../api/carePlan'

const state = {
	planDatas:{},
	sceneCategoryDatas:{},
	closePlanBackDatas:{}
}
const getters = {
	showPlanDatas(state){
		return state.planDatas
	},
	showSceneCategory(state){
		return state.sceneCategoryDatas
	},
	getClosePlanBackDatas(state){
		return state.closePlanBackDatas
	}
}
const actions = {
	searchPlan( {commit}, params ){
		carePlan.searchCares(params,function(cdata){
			commit(SET_PLAN_DATA,{data:cdata});
		})
	},
	searchSceneCategory( {commit}, params ){
		carePlan.searchScene(params,function(cdata){
			commit(SET_SCENE_DATA,{data:cdata});
		})
	},
	doClosePlan( {commit}, params ){
		carePlan.closePlan(params,function(cdata){
			commit(DO_CLOSE_PLAN,{data:cdata});
		})
	},
	planListExport( {commit}, data ){
		carePlan.planListExport(data.params,function(res){
			data.resolve(res);
		})
	},
	// 获取下载链接
	getExportDownloadUrl({},data){
		carePlan.getExportDownloadUrl(data.params,function (res) {
			data.resolve(res);
		})
	},
}
const mutations = {

	[SET_PLAN_DATA](state, { data }){
		state.planDatas = data;
	},
	[SET_SCENE_DATA](state, { data }){
		state.sceneCategoryDatas = data;
	},
	[DO_CLOSE_PLAN](state, { data }){
		state.closePlanBackDatas = data;
	},

}

export default {
    state,
    getters,
    actions,
    mutations
}
